/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { GlobalProtectedRoute } from 'framework/authorization';
import VacancyPublicationList from 'domain/recruiting/vacancy/publication/List';
import VacancyPublicationContext from 'domain/recruiting/vacancy/publication/VacancyPublicationContext';
import { CreateVacancyPublication, UpdateVacancyPublication } from 'domain/recruiting/vacancy/publication/createupdate';
import { createRoute, Route } from 'framework/routing';
import { ProtectedRouter } from 'infrastructure/routing';
import {
  CREATE_VACANCY_PUBLICATION,
  READ_VACANCY_PUBLICATION,
  READ_VACANCY_PUBLICATION_LIST,
  UPDATE_VACANCY_PUBLICATION,
  VACANCY_PUBLICATION_PATH,
} from 'domain/recruiting/vacancy/publication/shared/vacancyPublicationService';
import ViewVacancyPublication from 'domain/recruiting/vacancy/publication/Show';

const useVacancyPublicationRoute = () => {
  return createRoute({ listRoute: VACANCY_PUBLICATION_PATH });
};

const VacancyPublicationRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const {
    listRoute,
    singleEntityRoute,
    createRoute: createVacancyPublicationRoute,
    updateRoute,
  } = useVacancyPublicationRoute();

  return (
    <ProtectedRouter basePath={VACANCY_PUBLICATION_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_VACANCY_PUBLICATION_LIST}>
              <VacancyPublicationList />
            </GlobalProtectedRoute>
          }
        />
        <Route
          path={createVacancyPublicationRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={CREATE_VACANCY_PUBLICATION}>
              <CreateVacancyPublication />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={singleEntityRoute}
          element={
            <VacancyPublicationContext permissionToCheck={READ_VACANCY_PUBLICATION}>
              <ViewVacancyPublication />
            </VacancyPublicationContext>
          }
        />

        <Route
          path={updateRoute}
          element={
            <VacancyPublicationContext permissionToCheck={[UPDATE_VACANCY_PUBLICATION]}>
              <UpdateVacancyPublication />
            </VacancyPublicationContext>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

VacancyPublicationRouter.getRouterPath = () => `${VACANCY_PUBLICATION_PATH}/*`;

export default VacancyPublicationRouter;
